import { WdsIconNameEnum } from '@worksome/wds-components'

// Will convert a country iso code into a wds icon name enum. If it fails to find such an enum, it returns the Earth icon
export const computeFlagIcon = (countryCode: string) =>
  WdsIconNameEnum[`FLAG_${countryCode}`] ?? WdsIconNameEnum.EARTH
